'use strict';
moduleConfig.registerModule('eclipseApp.checkout', ['eclipseApp.core']);
